// ArticleList.js
import React, { useState } from 'react';
import { useEffect } from 'react';
import ArticlePreview from './ArticlePreview';
import '../css/style.css';

const LoadingSkeleton = () => (
  <div className="article-skeleton-list">
    {Array.from({ length: 4 }, (_, index) => (
      <div key={index} className="article-skeleton-card">
        <div className="skeleton-line skeleton-title" />
        <div className="skeleton-line skeleton-meta" />
        <div className="skeleton-line skeleton-meta short" />
        <div className="skeleton-line skeleton-body" />
      </div>
    ))}
  </div>
);

const ArticleList = ({ articles, loading, error, onRetry }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 10;

  useEffect(() => {
    setCurrentPage(1);
  }, [articles]);

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);
  const totalPages = Math.max(1, Math.ceil(articles.length / articlesPerPage));
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return <LoadingSkeleton />;
  }

  if (error) {
    return (
      <div className="article-state-card">
        <h3>Feed unavailable</h3>
        <p>{error}</p>
        <button type="button" className="state-action-btn" onClick={onRetry}>Try Again</button>
      </div>
    );
  }

  if (!articles.length) {
    return (
      <div className="article-state-card">
        <h3>No interviews found</h3>
        <p>Try broadening your filters or be the first person to share this interview experience.</p>
      </div>
    );
  }

  return (
    <section className="article-list-shell">
      <div className="article-list-summary">
        <p>{articles.length} interview{articles.length > 1 ? 's' : ''} found</p>
      </div>
      {currentArticles.map((article) => (
        <ArticlePreview key={article.id} article={article} />
      ))}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            type="button"
            onClick={() => paginate(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              type="button"
              className={currentPage === index + 1 ? 'active-page' : ''}
              onClick={() => paginate(index + 1)}
            >
            {index + 1}
            </button>
          ))}
          <button
            type="button"
            onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
};

export default ArticleList;

